export function normalizePlaceName(value) {
  return String(value || "")
    .normalize("NFKC")
    .toLocaleLowerCase("ko-KR")
    .replace(/<[^>]*>/g, "")
    .replace(/&(?:amp|nbsp|lt|gt|quot|#39);/g, "")
    .replace(/[^0-9a-z가-힣]/g, "");
}

export function isSamePlaceName(spotName, tourTitle) {
  const spot = normalizePlaceName(spotName);
  const tour = normalizePlaceName(tourTitle);
  if (!spot || !tour) return false;
  if (spot === tour) return true;

  const shorter = spot.length <= tour.length ? spot : tour;
  const longer = spot.length > tour.length ? spot : tour;

  // 수식어가 붙은 정식 명칭만 보완 매칭하고, 짧고 일반적인 이름의 오탐은 피한다.
  return shorter.length >= 5
    && longer.includes(shorter)
    && shorter.length / longer.length >= 0.65;
}

export function findTourMatch(spot, tourItems) {
  if (!spot?.name || !Array.isArray(tourItems)) return null;
  return tourItems.find(item =>
    isSamePlaceName(spot.name, item?.title || item?.name)
  ) || null;
}

export function getVerifiedSpotMatches(spots, tourItems, itineraryContent = "") {
  if (!Array.isArray(spots) || !Array.isArray(tourItems)) return [];

  const uniqueMatches = new Map();
  spots.forEach(spot => {
    if (!spot?.name) return;
    if (itineraryContent && !itineraryContent.includes(spot.name)) return;

    const tourItem = findTourMatch(spot, tourItems);
    if (!tourItem) return;

    const key = normalizePlaceName(tourItem.title || tourItem.name || spot.name);
    if (!uniqueMatches.has(key)) {
      uniqueMatches.set(key, { spot, tourItem });
    }
  });

  return Array.from(uniqueMatches.values());
}
